import { useQuery } from '@tanstack/react-query';

import { FetchCardRequest, cardsService, Card } from '@aslanpay/portal-common-lib';

const useFetchCard = ({ id }: FetchCardRequest, enabled = false) => {
  return useQuery<Card, Error>(['fetchCard', id], () => cardsService.fetchCard({ id }), {
    enabled: !!id && enabled,
  });
};

export default useFetchCard;
